import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { GridView } from '../../../components/GridView/GridView';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { TopicTeaser } from '../../../components/Teaser/TopicTeaser/TopicTeaser';
import { PageTitle } from '../../../components/Titles/PageTitle';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useTopicState } from '../../../providers/DataProvider/DataContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const gridConfig = [['small', {
  itemCount: 2,
  verticalSpacing: 8,
  horizontalSpacing: 8
}], ['medium', {
  itemCount: 4,
  verticalSpacing: 12,
  horizontalSpacing: 12
}], ['large', {
  itemCount: 5,
  verticalSpacing: 12,
  horizontalSpacing: 12
}], ['xLargeUp', {
  itemCount: 6,
  verticalSpacing: 12,
  horizontalSpacing: 12
}]];
export const DiscoverTopics = () => {
  const {
    t
  } = useTranslation();
  const {
    userTopics,
    isTopicsLoading
  } = useTopicState();
  const {
    search
  } = useVideoConfig();
  const showGrid = userTopics.length > 0 || isTopicsLoading;
  return /*#__PURE__*/_jsx(Fragment, {
    children: search.showTopicsSupported && /*#__PURE__*/_jsxs(PlayContainer, {
      children: [/*#__PURE__*/_jsx(PageTitle, {
        title: t('global.topics')
      }), showGrid && /*#__PURE__*/_jsx(GridView, {
        config: gridConfig,
        children: userTopics.map(topic => /*#__PURE__*/_jsx(TopicTeaser, {
          showFavoriteAction: false,
          topic: topic
        }, topic.id))
      })]
    })
  });
};